module.exports = __webpack_public_path__ + "./docs/img/big-icon-getter.ded6ec8400267316c0d9bf8193ef557b.svg";